import { styled } from '@mui/system';

export const Main = styled('main')`
  height: calc(100% - 20px);
  padding: 24px 16px;
`;